import Button from './buttons';
import Dialog from './dialog';

export default {
    Button,
    Dialog
}
